export default __webpack_public_path__ + "static/media/box2_step9.2c3a78c9.png";